import Logo from './Logo'
import MetaPhaseSymbol from '../brand/MetaPhaseSymbol'
import { EVENT_THEME } from '../../content/event'
import { COPYRIGHT_YEAR, OPERATOR } from '../../content/provenance'

/**
 * Site footer, a dark band in both themes: the hackathon on the left, the
 * MetaPhase credit on the right. The credit appears on every route.
 */
export default function SiteFooter() {
  return (
    <footer className="bg-[var(--footer)] text-[var(--footer-ink)]">
      <div className="page-shell flex flex-col gap-8 py-10 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-4">
          <Logo className="size-16" />
          <div>
            <p className="text-lg font-black tracking-tight">Hackathon</p>
            <p className="text-sm font-semibold text-[var(--footer-accent)] italic">{EVENT_THEME}</p>
          </div>
        </div>

        <div className="flex items-center gap-4 sm:flex-row-reverse sm:text-right">
          <MetaPhaseSymbol className="size-12 shrink-0 text-[var(--footer-accent)]" />
          <div>
            <p className="text-sm">
              Built by{' '}
              <a
                href={OPERATOR.url}
                rel="noreferrer"
                className="font-bold text-[var(--footer-accent)] underline-offset-2 hover:underline"
              >
                {OPERATOR.name}
              </a>
            </p>
            <p className="mt-1 text-xs text-[var(--footer-muted)]">&copy; {COPYRIGHT_YEAR} MetaPhase</p>
          </div>
        </div>
      </div>
    </footer>
  )
}
